export default class Validation {
  static emailIsValid = (emailInput) => {
    if (!emailInput) return

    const regex = /^[\w-.]+@[a-zA-Z0-9-_]+?\.[a-zA-Z]{2,3}$/
    const invalidEmails = []
    let emails = emailInput

    emails = emails.split(",")

    for (var i = 0; i < emails.length; i++) {
        emails[i] = emails[i].trim()

        if ( emails[i] === "" || ! regex.test(emails[i])){
            invalidEmails.push(emails[i])
        }
    }

    return invalidEmails.length === 0 ? undefined : `Invalid emails: ${invalidEmails.join(', ')}`
  }

  static phoneNumberIsValid = (number) => {
    if (!number) return
    return /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/.test(number) ? undefined : "Invalid Phone Number"
  }
}
